import { Button } from "react-bootstrap"

import PendingClinicalTest from "../../../api/OrphanedResults/Models/PendingClinicalTest"
import ActionButton from "../../ActionButton"

interface PendingClinicalTestsButtonsProps {
  selectedTest?: PendingClinicalTest
  selectedDonor?: boolean
  disabled?: boolean
  acceptSpin?: boolean
  createNewSpin?: boolean
  onCancel: () => void
  onCreateNew: () => void
  onAccept: () => void
}

function PendingClinicalTestsButtons({
  selectedTest = undefined,
  selectedDonor = false,
  disabled = false,
  acceptSpin = false,
  createNewSpin = false,
  onCancel,
  onCreateNew,
  onAccept,
}: PendingClinicalTestsButtonsProps) {
  return (
    <>
      <Button variant="primary" onClick={onCancel}>
        Cancel
      </Button>
      <ActionButton
        variant="secondary"
        onClick={onCreateNew}
        disabled={!!selectedTest || disabled || !!selectedDonor}
        spin={createNewSpin}
      >
        Create New
      </ActionButton>
      <ActionButton
        variant="secondary"
        onClick={onAccept}
        disabled={(!selectedTest && !selectedDonor) || disabled}
        spin={acceptSpin}
      >
        Accept
      </ActionButton>
    </>
  )
}

export default PendingClinicalTestsButtons
